window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ce-slider').length) {
    import('./_slider.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}
